export default "__VITE_ASSET__a93b536a__"